import { contactPathForMatch, type IncomingCallMatch } from "@/features/incomingCall/incomingCall";
import { Button } from "@/components/ui/Button";

export function IncomingCallDetails({
  matches,
  onOpen,
  showOpen = true,
}: {
  matches: IncomingCallMatch[];
  onOpen: (path: string) => void;
  showOpen?: boolean;
}) {
  if (matches.length === 0) {
    return (
      <p className="text-sm text-label-secondary">
        Zu dieser Nummer ist kein Kontakt hinterlegt.
      </p>
    );
  }

  return (
    <ul className="space-y-2">
      {matches.map((match) => {
        const path = contactPathForMatch(match);
        const kindLabel = match.kind === "ansprechpartner" ? "Ansprechpartner" : "Firma";
        return (
          <li
            key={`${match.geschaeftspartner_id}-${match.kind}-${match.label}`}
            className="flex items-center justify-between gap-3 rounded-lg bg-fill-tertiary px-3 py-2"
          >
            <div className="min-w-0">
              <div className="truncate text-sm font-medium text-label">{match.label}</div>
              <div className="text-xs text-label-secondary">{kindLabel}</div>
            </div>
            {showOpen && path ? (
              <Button type="button" size="sm" variant="secondary" onClick={() => onOpen(path)}>
                Öffnen
              </Button>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}
